import { Trans, t } from "@lingui/macro";
import { useEffect, useState } from "react";
import { AskBotEndpoint } from "../../models/BotMessage";
import { GetSoribotStatsResponse } from "../../models/DTO";
import { Soribot } from "../../models/Soribot";
import { Fire } from "../../services/FireClient";
import { UtilApp } from "../../services/Utils/UtilApp";
import BotMessageInfoModal from "./BotMessageInfoModal";
import { My } from "../../services/My";
import { Progress } from "../../components/ui/progress";
import { Loader2 } from "lucide-react";

export const SoribotStats: React.FC<{ bot: Soribot }> = ({ bot }) => {
  const [inProgress, setInProgress] = useState(false);
  const [resp, setResp] = useState<GetSoribotStatsResponse>();

  useEffect(() => {
    load();
  }, [bot.id])

  function load() {
    setInProgress(true);
    Fire.bot.getSoribotStats({ soribotId: bot.id }).then(data => {
      setResp(data);
    }).finally(() => {
      setInProgress(false);
    });
  }

  if (inProgress)
    return <div className="p-4 flex justify-center"><Loader2 className="animate-spin w-8 h-8" /></div>
  else
    return (<div className="space-y-4 p-4">
      {!resp && <div className="p-4 text-center text-muted-foreground">No response</div>}
      {resp && <>
        <div className="flex gap-8 mb-4">
          <div className="text-sm font-medium text-card-foreground"><Trans>Total prompts: {resp.count} times</Trans></div>
          <div className="text-sm font-medium text-card-foreground"><Trans>Suggestions used: {resp.suggestionCount} times</Trans></div>
        </div>

        <div className="border rounded-md overflow-hidden">
          <div className="bg-muted p-3 flex font-bold text-sm text-card-foreground border-b">
            <div className="flex-1"><Trans>Latest messages</Trans></div>
            <div className="w-32"><Trans>Client</Trans></div>
            <div className="w-16 text-center"><Trans>Info</Trans></div>
          </div>

          {resp.lastMessages.length === 0 && <div className="p-4 text-center text-muted-foreground"><Trans>No messages</Trans></div>}

          <div className="divide-y">
            {resp.lastMessages.map(m => (
              <div key={m.id} className="p-3 flex items-start text-sm hover:bg-muted/50">
                <div className="flex-1 pr-4">
                  <div className="mb-1 line-clamp-2">{m.userPrompt}</div>
                  <div className="flex items-center gap-2">
                    {m.suggestionId && <small className="font-bold text-muted-foreground">
                      {m.llmPrompt ? <Trans>Suggestion</Trans> : <Trans>Suggestion with a fixed answer</Trans>}
                    </small>}
                    <small className="text-muted-foreground">{UtilApp.dateStrToTimeAndDay(m.started, My.user.lang)}</small>
                  </div>
                </div>
                <div className="w-32 text-muted-foreground">{getEndpointText(m.endpoint)}</div>
                <div className="w-16 flex justify-center"><BotMessageInfoModal botMessageId={null} bmsg={m} /></div>
              </div>
            ))}
          </div>
        </div>
      </>}
    </div >
    );

  function getEndpointText(endpoint: AskBotEndpoint | undefined): string {
    switch (endpoint) {
      case 'app': return t`NEXTPOD`;
      case 'api': return t`Exposed API`;
      case 'public': return t`Public page`;
      default: return endpoint ?? t`NEXTPOD`;
    }
  }
}
export default SoribotStats;